module.exports = __webpack_public_path__ + "img/transitEpc.c57876fd.svg";